import axiosInstance from "../plugin/axios";

export interface LoginProps {
  companyCode: string;
  deviceId?: string;
  userAccount: string;
  password: string;
}

// 사용자
export const fetchLoadClientLogin = async (data: LoginProps) => {
  try {
    const response = await axiosInstance.post(`/client/web/login`, data);
    return response.data;
  } catch (error: any) {
    throw error; // 원본 AxiosError 그대로 throw
  }
};

// 관리자
export const fetchLoadAdminLogin = async (data: LoginProps) => {
  try {
    console.log("data:", data);
    const response = await axiosInstance.post(`/admin/web/login`, data);
    return response.data;
  } catch (error: any) {
    throw error; // 마찬가지
  }
};

export const fetchUpdatePasswordAdmin = async (
  targetUserId: number,
  password: string
) => {
  try {
    const response = await axiosInstance.post(`/admin/web/edit_password`, {
      targetUserId,
      changePassword: password,
    });

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const fetchUpdatePasswordUser = async (password: string) => {
  try {
    const response = await axiosInstance.post(`/client/web/edit_password`, {
      changePassword: password,
    });

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export interface CompanyRegisterDTO {
  newCompanyCode: string; // 회사 코드
  companyName: string; // 회사 이름
  adminUserAccount: string; // 관리자 계정 (아이디)
  adminPassword: string; // 관리자 비밀번호
  department: string; // 부서
  jobPosition: string; // 직위
  username: string; // 관리자 이름
  userEmail: string; // 관리자 이메일
  storageVolume: number; // 스토리지 용량 (단위: GB 등)
  accountNumLimit: number; // 계정 수 제한
  phoneNumber: string;
}

// 서비스 신청 (신규 회사 등록)
export const fetchNewCompanyRegist = async (params: CompanyRegisterDTO) => {
  try {
    const response = await axiosInstance.post("/admin/web/new_company", params);
    return response.data;
  } catch (err: any) {
    throw err;
  }
};
